import { Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

import {
  NetCashOutcome,
  SETTLEMENT_FINE_PRINT,
  getNetCashAmount,
  getNetCashOutcome,
} from '../../netCash';
import { AcceptedOffer, StageRenderState } from './utils';

type SigningSettlementLineProps = {
  stageState: StageRenderState;
  acceptedOffer?: AcceptedOffer;
  payoff?: number | null;
  showWhenUpcoming?: boolean;
  centered?: boolean;
};

const SigningSettlementLine = ({
  stageState,
  acceptedOffer,
  payoff,
  showWhenUpcoming,
  centered,
}: SigningSettlementLineProps) => {
  if (acceptedOffer == null || payoff == null) return null;

  const showsForState =
    stageState.startsWith('current') || (showWhenUpcoming === true && stageState === 'upcoming');
  if (!showsForState) return null;

  const outcome = getNetCashOutcome(acceptedOffer.amount, payoff);
  const amount = (
    <Text
      as="span"
      fontWeight="700"
      color="oceanBoatBlue"
      sx={{ fontVariantNumeric: 'tabular-nums' }}
    >
      {getNetCashAmount(acceptedOffer.amount, payoff)}
    </Text>
  );
  const message: Record<NetCashOutcome, ReactNode> = {
    breakEven: "You're right at your payoff; any difference settles here.",
    positive: <>This is also where you get paid: about {amount} comes to you.</>,
    negative: (
      <>
        You'll also settle up here: plan on about {amount}, your offer against your confirmed
        payoff.
      </>
    ),
  };

  return (
    <>
      <Text
        mt="6px"
        fontSize="12.5px"
        lineHeight="1.5"
        color="charcoal"
        textAlign={centered ? 'center' : undefined}
      >
        {message[outcome]}
      </Text>
      <Text
        mt="4px"
        fontSize="12px"
        lineHeight="1.5"
        color="grayLight"
        textAlign={centered ? 'center' : undefined}
      >
        {SETTLEMENT_FINE_PRINT}
      </Text>
    </>
  );
};

export default SigningSettlementLine;
